import {v4} from 'uuid';


/**
 * @return {string} UUID v4 time based
 */
export const generateUuid = () => {

    return v4();
};
